import { render } from "./Index.vue?vue&type=template&id=e3bd691e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=e3bd691e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e3bd691e"

export default script